import React, { useState } from "react";
import "./navbar.css";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaUserDoctor } from "react-icons/fa6";

function CustomNavbar() {
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const [showConcernsDropdown, setShowConcernsDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <Navbar variant="light" expand="lg" className="custom-navbar">
      <Container className="m-0 p-0">
        {/* Brand Logo + Text */}
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src="/logo.png" // ✅ from public folder
            alt="Clinic Logo"
            height="80"
            className="d-inline-block align-top me-2"
          />
          <motion.div
            className="brand-text text-start"
            whileHover={{ scale: 1.05, color: "#0077b6" }} // hover animation
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="clinic-name fw-bold">DR. TRUPTI'S </div>
            <div className="clinic-sub">Health And Beauty Clinic</div>
          </motion.div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="mobile-menu">
          <Nav className="ms-auto">
            <Nav.Link className="fs-6 fw-bold nav-links" as={Link} to="/">
              HOME
            </Nav.Link>

            <NavDropdown
              className="fs-6 fw-bold nav-links"
              title="ABOUT US"
              id="services-dropdown"
              show={showAboutDropdown}
              onMouseEnter={() => setShowAboutDropdown(true)}
              onMouseLeave={() => setShowAboutDropdown(false)}
            >
              <NavDropdown.Item className="fs-6" as={Link} to="/Doctors">ABOUT DOCTOR</NavDropdown.Item>
              <NavDropdown.Item href="#about-clinic">ABOUT CLINIC</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="CONCERNS"
              className="fs-6 fw-bold nav-links"
              show={showConcernsDropdown}
              onMouseEnter={() => setShowConcernsDropdown(true)}
              onMouseLeave={() => setShowConcernsDropdown(false)}
            >
              <NavDropdown.Item as={Link} to="/skin-concerns">Skin Concerns</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/hair-concerns">Hair Concerns</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="TREATMENTS"
              className="fs-6 fw-bold nav-links"
              show={showDropdown}
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
            >
              <NavDropdown.Item as={Link} to="/treatments">All Treatments</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/treatments/acne">Acne & Scar Treatment</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/tattoo">Tattoo Removal</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/hair">Hair Treatment</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/carbon-laser-facial">Carbon Laser Facial</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/laserhair">Laser Hair Removal</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/antiaging">Anti-Aging Treatment</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/microneedling">Microneedling</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/chemicalpeel">Chemical Peeling</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/nail-disease">Nail Diseases & Treatment</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/skintag-removal">Skin Tag, Birthmark, Mole & Wart Removal</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/prp">PRP Treatment</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/treatments/fungalinfection">Fungal Infection</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link className="fs-6 fw-bold nav-links" as={Link} to="/products">PRODUCTS</Nav.Link>
            <Nav.Link className="fs-6 fw-bold nav-links" as={Link} to="/ContactUs">CONTACT US</Nav.Link>
            <Nav.Link as={Link} to="/login" className="fs-6 fw-bold nav-links"><FaUserDoctor size={20} /></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default CustomNavbar;
